import Client from 'Api/Client';
import EndPoint from 'Api/EndPoint';

const endpoint = `${EndPoint.Host}/${EndPoint.Inquiry}`;

export async function uploadFileInquiryImage(image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/image`, 'image', image, onProgress);
}

export async function postInquiryImage(data) {
  return await Client.post(`${endpoint}`, data, true);
}
